export default __webpack_public_path__ + "assets/circle-icon-add-component.e714768b.svg";